import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { Typography } from '@one-thd/sui-atomic-components';
import { SalientIconItem } from './SalientIconItem';
import { ViewMoreLink } from './ViewMoreLink';
import { track } from '../../utils';

const pt = PropTypes;

const SalientIconsLayout = ({
  iconBasedPoints, max, itemId, children, highlights, salientIconsTest
}) => {
  useEffect(() => {
    track('salient-points', 'icon-test', { salientType: salientIconsTest });
  }, []);

  return (
    <>
      <div className="sui-flex sui-flex-col sui-gap-6 sm:sui-gap-4 lg:sui-gap-6 xl:sui-gap-4">
        <Typography variant="h5">
          Key Features
        </Typography>
        <div className="sui-flex sui-flex-col sui-gap-6 sm:sui-gap-4 lg:sui-gap-6 xl:sui-gap-4">
          {/* eslint-disable-next-line max-len */}
          <div className="sui-w-full sui-flex sui-gap-4 sui-flex-col sui-items-start sm:sui-items-center lg:sui-items-start xl:sui-items-center sm:sui-flex-row lg:sui-flex-col xl:sui-flex-row">
            {iconBasedPoints.slice(0, max).map((iconData) => (
              <SalientIconItem
                key={`icon-${iconData.text}-${itemId}`}
                iconData={iconData}
              />
            ))}
          </div>
          <ViewMoreLink
            max={max}
            highlights={highlights}
            salientIconsTest={salientIconsTest}
          >
            {children}
          </ViewMoreLink>
        </div>
      </div>
    </>
  );
};

SalientIconsLayout.propTypes = {
  iconBasedPoints: pt.arrayOf(pt.shape({
    text: pt.string.isRequired,
    icon: pt.func.isRequired
  })).isRequired,
  max: pt.number.isRequired,
  itemId: pt.string.isRequired,
  highlights: pt.arrayOf(pt.string),
  children: pt.node,
  salientIconsTest: pt.string.isRequired
};

SalientIconsLayout.defaultProps = {
  highlights: [],
  children: null,
};

export { SalientIconsLayout };
